export const SPEC_TYPE_LABELS: Record<string, string> = {
  'WPS': 'Welding Procedure Specification',
  'DRAWING': 'Drawing',
  'WELD_PROCESS': 'Weld Process',
  'INSPECTION_PROCEDURE': 'Inspection Procedure',
  'ACCEPTANCE_CRITERIA': 'Acceptance Criteria',
  'ALIGNMENT': 'Alignment',
  'PASS_CONFIG': 'Pass Configuration',
  'FITMENT_READINGS': 'Fitment Readings',
 // 'WELDING_POSITION': 'Welding Position',
  //'BEVEL': 'Bevel Details',
  'OTHERS': 'Others',
  'FAT': 'FAT',
  'COATING': 'Coating'
} as const; 

export const SPEC_TYPE_KEYS: Record<string, string> = {
 'Welding Procedure Specification' : 'WPS',
  'Drawing': 'DRAWING',
  'Weld Process': 'WELD_PROCESS',
  'Inspection Procedure': 'INSPECTION_PROCEDURE',
  'Acceptance Criteria': 'ACCEPTANCE_CRITERIA',
  'Alignment': 'ALIGNMENT',
  'Pass Configuration': 'PASS_CONFIG',
  'Fitment Readings': 'FITMENT_READINGS',
//  'Welding Position': 'WELDING_POSITION',
 // 'Bevel Details': 'BEVEL',
  'Others': 'OTHERS',
  'FAT': 'FAT',
  'COATING': 'COATING'
} as const;

// Specification tag types mapping
export const SPEC_TAG_TYPES: Record<string, string> = {
  'WPS': 'SPECIFICATION_WPS_TAGS',
  'DRAWING': 'SPECIFICATION_DRAWING_TAGS',
  'WELD_PROCESS': 'SPECIFICATION_WELD_PROCESS_TAGS',
  'INSPECTION_PROCEDURE': 'SPECIFICATION_INSPECTION_PROCEDURE_TAGS',
  'ACCEPTANCE_CRITERIA': 'SPECIFICATION_ACCEPTANCE_CRITERIA_TAGS',
  'ALIGNMENT': 'SPECIFICATION_ALIGNMENT_TAGS',
  'PASS_CONFIG': 'SPECIFICATION_PASS_CONFIG_TAGS',
  'FITMENT_READINGS': 'SPECIFICATION_FITMENT_READINGS_TAGS',
  'OTHERS': 'SPECIFICATION_OTHERS_TAGS',
  'FAT': 'SPECIFICATION_OTHERS_TAGS',
  'COATING': 'SPECIFICATION_COATING_TAGS',
  'NDT': 'SPECIFICATION_NDT_TAGS',
  'Coating': 'SPECIFICATION_COATING_TAGS',
  'ARC_STRIKE_REPORT': 'SPECIFICATION_ARC_STRIKE_REPORT_TAGS',
  'TQ': 'SPECIFICATION_TQ_TAGS'
} as const; 